module.exports = __webpack_public_path__ + "img/asesoriaestudiante.71f7d5d9.png";